import React from "react";
import { render } from "react-dom";

import VisibilitySensor from "react-visibility-sensor";

import Carousel from "components/Carousel";
import SellingPoint from "components/SellingPoint";
import "helpers/lazyLoad";

import "./style.scss";

// Selling Points

const ethicsPointsSettings = {
  arrows: false,
  autoplay: false,
  autoplaySpeed: 12 * 1e3,
  className: "carousel --fade",
  dots: true,
  dotsClass: "slick-dots carousel__dots --bigger --inverse",
  fade: true,
  infinite: true,
  speed: 500,
};

const ethicsPointsElem = document.getElementById("js-ethics-points");
if (ethicsPointsElem !== null) {
  render(
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <Carousel
          settings={{
            ...ethicsPointsSettings,
            autoplay: isVisible,
          }}
          key={isVisible ? "0" : "1"}
        >
          <SellingPoint heading="We're a social enterprise">
            “Our social mission is embedded into our Constitution, which means that we consider it
            in all our decision making. We want to show the world that you can create the best
            fundraising platform in the world and still be a purpose-first company.”
          </SellingPoint>
          <SellingPoint heading="High quality campaigns">
            “We don't believe platforms like us should be neutral, so we only support campaigns that
            align with our values&mdash;that means no hate campaigns, no misogyny and no robbing the
            poor to feed the rich. Browse through our Discover page and you'll see what we're
            about.”
          </SellingPoint>
        </Carousel>
      )}
    </VisibilitySensor>,
    ethicsPointsElem,
  );
}
